















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import FiltroMagistrados from '@/model/filtros/FiltroMagistrados'
import { validateCuit } from '@/utils/ValidationUtil'
@Component({ components: {} })
export default class FiltrosMagistrados extends Vue {
  @Prop()
  private filtro: FiltroMagistrados

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean
      resetValidation(): void
    }
  }
  validateCuit(cuit: string) {
    return validateCuit(cuit)
  }
  validate() {
    return this.form().validate()
  }

  resetValidation() {
    this.form().resetValidation()
  }

  private get tieneApellido() {
    if (this.filtro.apellido) {
      this.filtro.cuil = (undefined as unknown) as number
      return true
    }
    return false
  }
  private get tieneCuil() {
    if (this.filtro.cuil) {
      this.filtro.apellido = (undefined as unknown) as string
      return true
    }
    return false
  }
}
